

  <div class="container">
    <div class="navbar-nav-wrap">
      <!-- Logo -->
      <a class="navbar-brand" href="../index.html" aria-label="Front">
        <img class="navbar-brand-logo" src="images/icon.png" alt="Logo" data-hs-theme-appearance="default" style="min-width: 3.0rem;max-width: 3.0rem;">
        <img class="navbar-brand-logo" src="images/TrunkTrack.png" alt="Logo" data-hs-theme-appearance="dark">
      </a>
      <!-- End Logo -->

      <div class="navbar-nav-wrap-content-end">
        <!-- Navbar -->
        <ul class="navbar-nav">
<!--          <li class="nav-item d-none d-md-inline-block">-->
<!--            &lt;!&ndash; Notification &ndash;&gt;-->
<!--            <div class="dropdown">-->
<!--              <button type="button" class="btn btn-ghost-secondary btn-icon rounded-circle" id="navbarNotificationsDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" data-bs-dropdown-animation="">-->
<!--                <i class="bi-bell"></i>-->
<!--                <span class="btn-status btn-sm-status btn-status-danger"></span>-->
<!--              </button>-->

<!--              <div class="dropdown-menu dropdown-menu-end dropdown-card navbar-dropdown-menu navbar-dropdown-menu-borderless" aria-labelledby="navbarNotificationsDropdown" style="width: 25rem;">-->
<!--                <div class="card">-->
<!--                  &lt;!&ndash; Header &ndash;&gt;-->
<!--                  <div class="card-header card-header-content-between">-->
<!--                    <h4 class="card-title mb-0">Notifications</h4>-->

<!--                    &lt;!&ndash; Unfold &ndash;&gt;-->
<!--                    <div class="dropdown">-->
<!--                      <button type="button" class="btn btn-icon btn-sm btn-ghost-secondary rounded-circle" id="navbarNotificationsDropdownSettings" data-bs-toggle="dropdown" aria-expanded="false">-->
<!--                        <i class="bi-three-dots-vertical"></i>-->
<!--                      </button>-->

<!--                      <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless" aria-labelledby="navbarNotificationsDropdownSettings">-->
<!--                        <span class="dropdown-header">Settings</span>-->
<!--                        <a class="dropdown-item" href="#">-->
<!--                          <i class="bi-archive dropdown-item-icon"></i> Archive all-->
<!--                        </a>-->
<!--                        <a class="dropdown-item" href="#">-->
<!--                          <i class="bi-check2-all dropdown-item-icon"></i> Mark all as read-->
<!--                        </a>-->
<!--                        <a class="dropdown-item" href="#">-->
<!--                          <i class="bi-toggle-off dropdown-item-icon"></i> Disable notifications-->
<!--                        </a>-->
<!--                        <a class="dropdown-item" href="#">-->
<!--                          <i class="bi-gift dropdown-item-icon"></i> What's new?-->
<!--                        </a>-->
<!--                        <div class="dropdown-divider"></div>-->
<!--                        <span class="dropdown-header">Feedback</span>-->
<!--                        <a class="dropdown-item" href="#">-->
<!--                          <i class="bi-chat-left-dots dropdown-item-icon"></i> Report-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; End Unfold &ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash; End Header &ndash;&gt;-->

<!--                  &lt;!&ndash; Nav &ndash;&gt;-->
<!--                  <ul class="nav nav-tabs nav-justified" id="notificationTab" role="tablist">-->
<!--                    <li class="nav-item" role="presentation">-->
<!--                      <a class="nav-link active" href="#notificationNavOne" id="notificationNavOne-tab" data-bs-toggle="tab" data-bs-target="#notificationNavOne" role="tab" aria-controls="notificationNavOne" aria-selected="true">Messages (3)</a>-->
<!--                    </li>-->
<!--                    <li class="nav-item" role="presentation">-->
<!--                      <a class="nav-link" href="#notificationNavTwo" id="notificationNavTwo-tab" data-bs-toggle="tab" data-bs-target="#notificationNavTwo" role="tab" aria-controls="notificationNavTwo" aria-selected="false" tabindex="-1">Archived</a>-->
<!--                    </li>-->
<!--                  </ul>-->
<!--                  &lt;!&ndash; End Nav &ndash;&gt;-->

<!--                  &lt;!&ndash; Body &ndash;&gt;-->
<!--                  <div class="card-body-height">-->
<!--                    &lt;!&ndash; Tab Content &ndash;&gt;-->
<!--                    <div class="tab-content" id="notificationTabContent">-->
<!--                      <div class="tab-pane fade show active" id="notificationNavOne" role="tabpanel" aria-labelledby="notificationNavOne-tab">-->
<!--                        &lt;!&ndash; List Group &ndash;&gt;-->
<!--                        <ul class="list-group list-group-flush navbar-card-list-group">-->
<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck1" checked="">-->
<!--                                    <label class="form-check-label" for="notificationCheck1"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <img class="avatar avatar-sm avatar-circle" src="../assets/img/160x160/img3.jpg" alt="Image Description">-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Brian Warner</h5>-->
<!--                                <p class="text-body fs-5">changed an issue from "In Progress" to <span class="badge bg-success">Review</span></p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">2hr</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck2" checked="">-->
<!--                                    <label class="form-check-label" for="notificationCheck2"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-soft-dark avatar-circle">-->
<!--                                    <span class="avatar-initials">K</span>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Klara Hampton</h5>-->
<!--                                <p class="text-body fs-5">mentioned you in a comment</p>-->
<!--                                <blockquote class="blockquote blockquote-sm">-->
<!--                                  Nice work, love! You really nailed it. Keep it up!-->
<!--                                </blockquote>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">10hr</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck3" checked="">-->
<!--                                    <label class="form-check-label" for="notificationCheck3"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-circle">-->
<!--                                    <img class="avatar-img" src="../assets/img/160x160/img10.jpg" alt="Image Description">-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Ruby Walter</h5>-->
<!--                                <p class="text-body fs-5">joined the Slack group HS Team</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">3dy</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck4">-->
<!--                                    <label class="form-check-label" for="notificationCheck4"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-circle">-->
<!--                                    <img class="avatar-img" src="../assets/svg/brands/google-icon.svg" alt="Image Description">-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">from Google</h5>-->
<!--                                <p class="text-body fs-5">Start using forms to capture the information of prospects visiting your Google website</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">17dy</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck5">-->
<!--                                    <label class="form-check-label" for="notificationCheck5"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-circle">-->
<!--                                    <img class="avatar-img" src="../assets/img/160x160/img7.jpg" alt="Image Description">-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Sara Villar</h5>-->
<!--                                <p class="text-body fs-5">completed <i class="bi-journal-bookmark-fill text-primary"></i> FD-7 task</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">2mn</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->
<!--                        </ul>-->
<!--                        &lt;!&ndash; End List Group &ndash;&gt;-->
<!--                      </div>-->

<!--                      <div class="tab-pane fade" id="notificationNavTwo" role="tabpanel" aria-labelledby="notificationNavTwo-tab">-->
<!--                        &lt;!&ndash; List Group &ndash;&gt;-->
<!--                        <ul class="list-group list-group-flush navbar-card-list-group">-->
<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck6">-->
<!--                                    <label class="form-check-label" for="notificationCheck6"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-soft-dark avatar-circle">-->
<!--                                    <span class="avatar-initials">A</span>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Anne Richard</h5>-->
<!--                                <p class="text-body fs-5">accepted your invitation to join Notion</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">1dy</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck7">-->
<!--                                    <label class="form-check-label" for="notificationCheck7"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-circle">-->
<!--                                    <img class="avatar-img" src="../assets/img/160x160/img5.jpg" alt="Image Description">-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Finch Hoot</h5>-->
<!--                                <p class="text-body fs-5">left Slack group HS projects</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">1dy</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck8">-->
<!--                                    <label class="form-check-label" for="notificationCheck8"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-dark avatar-circle">-->
<!--                                    <span class="avatar-initials">HS</span>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Htmlstream</h5>-->
<!--                                <p class="text-body fs-5">you earned a "Top endorsed" <i class="bi-patch-check-fill text-primary"></i> badge</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">6dy</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck9">-->
<!--                                    <label class="form-check-label" for="notificationCheck9"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-circle">-->
<!--                                    <img class="avatar-img" src="../assets/img/160x160/img8.jpg" alt="Image Description">-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Linda Bates</h5>-->
<!--                                <p class="text-body fs-5">Accepted your connection</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">17dy</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->

<!--                          &lt;!&ndash; Item &ndash;&gt;-->
<!--                          <li class="list-group-item form-check-select">-->
<!--                            <div class="row">-->
<!--                              <div class="col-auto">-->
<!--                                <div class="d-flex align-items-center">-->
<!--                                  <div class="form-check">-->
<!--                                    <input class="form-check-input" type="checkbox" value="" id="notificationCheck10">-->
<!--                                    <label class="form-check-label" for="notificationCheck10"></label>-->
<!--                                    <span class="form-check-stretched-bg"></span>-->
<!--                                  </div>-->
<!--                                  <div class="avatar avatar-sm avatar-soft-dark avatar-circle">-->
<!--                                    <span class="avatar-initials">L</span>-->
<!--                                  </div>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <div class="col ms-n2">-->
<!--                                <h5 class="mb-1">Lewis Clarke</h5>-->
<!--                                <p class="text-body fs-5">completed <i class="bi-journal-bookmark-fill text-primary"></i> FD-134 task</p>-->
<!--                              </div>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->

<!--                              <small class="col-auto text-muted text-cap">2mts</small>-->
<!--                              &lt;!&ndash; End Col &ndash;&gt;-->
<!--                            </div>-->
<!--                            &lt;!&ndash; End Row &ndash;&gt;-->

<!--                            <a class="stretched-link" href="#"></a>-->
<!--                          </li>-->
<!--                          &lt;!&ndash; End Item &ndash;&gt;-->
<!--                        </ul>-->
<!--                        &lt;!&ndash; End List Group &ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    &lt;!&ndash; End Tab Content &ndash;&gt;-->
<!--                  </div>-->
<!--                  &lt;!&ndash; End Body &ndash;&gt;-->

<!--                  &lt;!&ndash; Card Footer &ndash;&gt;-->
<!--                  <a class="card-footer text-center" href="#">-->
<!--                    View all notifications <i class="bi-chevron-right"></i>-->
<!--                  </a>-->
<!--                  &lt;!&ndash; End Card Footer &ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash; End Notification &ndash;&gt;-->
<!--          </li>-->

<!--          <li class="nav-item d-none d-sm-inline-block">-->
<!--            &lt;!&ndash; Apps &ndash;&gt;-->
<!--            <div class="dropdown">-->
<!--              <button type="button" class="btn btn-icon btn-ghost-secondary rounded-circle" id="navbarAppsDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-dropdown-animation="">-->
<!--                <i class="bi-app-indicator"></i>-->
<!--              </button>-->

<!--              <div class="dropdown-menu dropdown-menu-end dropdown-card navbar-dropdown-menu navbar-dropdown-menu-borderless" aria-labelledby="navbarAppsDropdown" style="width: 25rem;">-->
<!--                <div class="card">-->
<!--                  &lt;!&ndash; Header &ndash;&gt;-->
<!--                  <div class="card-header">-->
<!--                    <h4 class="card-title">Web apps &amp; services</h4>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; End Header &ndash;&gt;-->

<!--                  &lt;!&ndash; Body &ndash;&gt;-->
<!--                  <div class="card-body card-body-height">-->
<!--                    <a class="dropdown-item" href="#">-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        <div class="flex-shrink-0">-->
<!--                          <img class="avatar avatar-xs avatar-4x3" src="../assets/svg/brands/atlassian-icon.svg" alt="Image Description">-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 text-truncate ms-3">-->
<!--                          <h5 class="mb-0">Atlassian</h5>-->
<!--                          <p class="card-text text-body">Security and control across Cloud</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->

<!--                    <a class="dropdown-item" href="#">-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        <div class="flex-shrink-0">-->
<!--                          <img class="avatar avatar-xs avatar-4x3" src="../assets/svg/brands/slack-icon.svg" alt="Image Description">-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 text-truncate ms-3">-->
<!--                          <h5 class="mb-0">Slack <span class="badge bg-primary rounded-pill text-uppercase ms-1">Try</span></h5>-->
<!--                          <p class="card-text text-body">Email collaboration software</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->

<!--                    <a class="dropdown-item" href="#">-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        <div class="flex-shrink-0">-->
<!--                          <img class="avatar avatar-xs avatar-4x3" src="../assets/svg/brands/google-webdev-icon.svg" alt="Image Description">-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 text-truncate ms-3">-->
<!--                          <h5 class="mb-0">Google webdev</h5>-->
<!--                          <p class="card-text text-body">Work involved in developing a website</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->

<!--                    <a class="dropdown-item" href="#">-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        <div class="flex-shrink-0">-->
<!--                          <img class="avatar avatar-xs avatar-4x3" src="../assets/svg/brands/frontapp-icon.svg" alt="Image Description">-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 text-truncate ms-3">-->
<!--                          <h5 class="mb-0">Frontapp</h5>-->
<!--                          <p class="card-text text-body">The inbox for teams</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->

<!--                    <a class="dropdown-item" href="#">-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        <div class="flex-shrink-0">-->
<!--                          <img class="avatar avatar-xs avatar-4x3" src="../assets/svg/illustrations/review-rating-shield.svg" alt="Image Description">-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 text-truncate ms-3">-->
<!--                          <h5 class="mb-0">HS Support</h5>-->
<!--                          <p class="card-text text-body">Customer service and support</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->

<!--                    <a class="dropdown-item" href="#">-->
<!--                      <div class="d-flex align-items-center">-->
<!--                        <div class="flex-shrink-0">-->
<!--                          <div class="avatar avatar-sm avatar-soft-dark">-->
<!--                            <span class="avatar-initials"><i class="bi-grid"></i></span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                        <div class="flex-grow-1 text-truncate ms-3">-->
<!--                          <h5 class="mb-0">More Front products</h5>-->
<!--                          <p class="card-text text-body">Check out more HS products</p>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  &lt;!&ndash; End Body &ndash;&gt;-->

<!--                  &lt;!&ndash; Footer &ndash;&gt;-->
<!--                  <a class="card-footer text-center" href="#">-->
<!--                    View all apps <i class="bi-chevron-right"></i>-->
<!--                  </a>-->
<!--                  &lt;!&ndash; End Footer &ndash;&gt;-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash; End Apps &ndash;&gt;-->
<!--          </li>-->

<!--          <li class="nav-item d-none d-sm-inline-block">-->
<!--            &lt;!&ndash; Activity &ndash;&gt;-->
<!--            <button class="btn btn-ghost-secondary btn-icon rounded-circle" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasActivityStream" aria-controls="offcanvasActivityStream">-->
<!--              <i class="bi-x-diamond"></i>-->
<!--            </button>-->
<!--            &lt;!&ndash; Activity &ndash;&gt;-->
<!--          </li>-->

<!--          <li class="nav-item">-->
<!--            &lt;!&ndash; Account &ndash;&gt;-->
<!--            <div class="dropdown">-->
<!--              <a class="navbar-dropdown-account-wrapper" href="javascript:;" id="accountNavbarDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" data-bs-dropdown-animation="">-->
<!--                <div class="avatar avatar-sm avatar-circle">-->
<!--                  <img class="avatar-img" src="../assets/img/160x160/img6.jpg" alt="Image Description">-->
<!--                  <span class="avatar-status avatar-sm-status avatar-status-success"></span>-->
<!--                </div>-->
<!--              </a>-->

<!--              <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-account" aria-labelledby="accountNavbarDropdown" style="width: 16rem;">-->
<!--                <div class="dropdown-item-text">-->
<!--                  <div class="d-flex align-items-center">-->
<!--                    <div class="avatar avatar-sm avatar-circle">-->
<!--                      <img class="avatar-img" src="../assets/img/160x160/img6.jpg" alt="Image Description">-->
<!--                    </div>-->
<!--                    <div class="flex-grow-1 ms-3">-->
<!--                      <h5 class="mb-0">Mark Williams</h5>-->
<!--                      <p class="card-text text-body"></p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="dropdown-divider"></div>-->

<!--                &lt;!&ndash; Dropdown &ndash;&gt;-->
<!--                <div class="dropdown">-->
<!--                  <a class="navbar-dropdown-submenu-item dropdown-item dropdown-toggle" href="javascript:;" id="navSubmenuPagesAccountDropdown1" data-bs-toggle="dropdown" aria-expanded="false">Set status</a>-->

<!--                  <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-sub-menu" aria-labelledby="navSubmenuPagesAccountDropdown1">-->
<!--                    <a class="dropdown-item" href="#">-->
<!--                      <span class="legend-indicator bg-success me-1"></span> Available-->
<!--                    </a>-->
<!--                    <a class="dropdown-item" href="#">-->
<!--                      <span class="legend-indicator bg-danger me-1"></span> Busy-->
<!--                    </a>-->
<!--                    <a class="dropdown-item" href="#">-->
<!--                      <span class="legend-indicator bg-warning me-1"></span> Away-->
<!--                    </a>-->
<!--                    <div class="dropdown-divider"></div>-->
<!--                    <a class="dropdown-item" href="#"> Reset status-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash; End Dropdown &ndash;&gt;-->

<!--                <a class="dropdown-item" href="#">Profile &amp; account</a>-->
<!--                <a class="dropdown-item" href="#">Settings</a>-->

<!--                <div class="dropdown-divider"></div>-->

<!--                <a class="dropdown-item" href="#">-->
<!--                  <div class="d-flex align-items-center">-->
<!--                    <div class="flex-shrink-0">-->
<!--                      <div class="avatar avatar-sm avatar-dark avatar-circle">-->
<!--                        <span class="avatar-initials">HS</span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="flex-grow-1 ms-2">-->
<!--                      <h5 class="mb-0">Htmlstream <span class="badge bg-primary rounded-pill text-uppercase ms-1">PRO</span></h5>-->
<!--                      <span class="card-text">hs.example.com</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </a>-->

<!--                <div class="dropdown-divider"></div>-->

<!--                &lt;!&ndash; Dropdown &ndash;&gt;-->
<!--                <div class="dropdown">-->
<!--                  <a class="navbar-dropdown-submenu-item dropdown-item dropdown-toggle" href="javascript:;" id="navSubmenuPagesAccountDropdown2" data-bs-toggle="dropdown" aria-expanded="false">Customization</a>-->

<!--                  <div class="dropdown-menu dropdown-menu-end navbar-dropdown-menu navbar-dropdown-menu-borderless navbar-dropdown-sub-menu" aria-labelledby="navSubmenuPagesAccountDropdown2">-->
<!--                    <a class="dropdown-item" href="#">-->
<!--                      Invite people-->
<!--                    </a>-->
<!--                    <a class="dropdown-item" href="#">-->
<!--                      Analytics-->
<!--                      <i class="bi-box-arrow-in-up-right"></i>-->
<!--                    </a>-->
<!--                    <a class="dropdown-item" href="#">-->
<!--                      Customize Front-->
<!--                      <i class="bi-box-arrow-in-up-right"></i>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--                &lt;!&ndash; End Dropdown &ndash;&gt;-->

<!--                <a class="dropdown-item" href="#">Manage team</a>-->

<!--                <div class="dropdown-divider"></div>-->

<!--                <a class="dropdown-item" href="#">Sign out</a>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash; End Account &ndash;&gt;-->
<!--          </li>-->
        </ul>
        <!-- End Navbar -->
      </div>
    </div>
  </div>

